import { getMobileCellRole, type TMobileCellRole } from './getMobileCellRole';

export const labelMobileTable = (table: HTMLTableElement) => {
  const headers = Array.from(table.tHead?.rows[table.tHead.rows.length - 1]?.cells ?? []);
  const labels = headers.map((header) => header.getAttribute('data-mobile-label') ?? header.textContent?.trim() ?? '');
  const pinnedColumns = headers.map((header) => header.hasAttribute('data-mobile-summary'));
  for (const body of Array.from(table.tBodies)) {
    for (const row of Array.from(body.rows)) {
      let column = 0;
      let details = 0;
      let hasTitle = false;
      for (const cell of Array.from(row.cells)) {
        if (cell.hasAttribute('data-mobile-toggle')) {
          continue;
        }
        const label = labels[column] ?? '';
        cell.dataset.mobileLabel = cell.colSpan > 1 ? '' : label;
        const summary =
          cell.colSpan > 1 ||
          column < 2 ||
          pinnedColumns[column] ||
          !label ||
          /\b(name|title|status|actions?|select|id)\b/i.test(label);
        cell.dataset.mobileDetail = String(!summary);
        if (!summary) {
          details += 1;
        }
        const role: TMobileCellRole | undefined =
          cell.colSpan > 1 ? undefined : getMobileCellRole(label, column, hasTitle);
        if (role) {
          cell.dataset.mobileRole = role;
          hasTitle = hasTitle || role === 'title';
        } else {
          delete cell.dataset.mobileRole;
        }
        column += cell.colSpan;
      }
      row.dataset.mobileHasDetails = String(details > 0);
    }
  }
};
